export const enum CustomerSettingsKeys {
  max_linear_stream_time = 'max_linear_stream_time',
}
